'use client'

import React, { useEffect } from 'react'
import CompanyForm from './CompanyForm'

interface CompanyFormModalProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: (data: any) => void
}

export default function CompanyFormModal({ isOpen, onClose, onSuccess }: CompanyFormModalProps) {
  
  // Body scroll lock effect
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  // Overlay super claro, Modal travado na tela e apenas o conteúdo rola.
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 sm:p-6 bg-black/10 backdrop-blur-md transition-opacity">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full flex flex-col max-h-[95vh] sm:max-h-[90vh] transform transition-all scale-100">
        
        {/* Header/Close Button (Fixo no topo do card) */}
        <div className="absolute top-3 right-3 sm:top-4 sm:right-4 z-10">
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 rounded-full p-2 transition-colors focus:outline-none"
            title="Fechar Formulário"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content Body (Rolagem isolada internamente) */}
        <div className="overflow-y-auto w-full pt-10 pb-4 px-4 sm:px-8 custom-scrollbar rounded-b-2xl">
           <CompanyForm onSuccess={onSuccess} isModal={true} />
        </div>
      </div>
    </div>
  )
}
